var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "#E2A400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3940_21520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1819 9.2743C17.0936 8.1878 15.5084 8.0313 14.0168 7.9944C13.332 7.976 12.7478 7.9668 12.1635 7.9668C11.5792 7.9668 10.995 7.976 10.3102 7.9944C8.82803 8.0313 7.23333 8.1878 6.14523 9.2743C5.01953 10.4071 5.02893 12.2488 5.00073 13.7039V17.3046C5.02893 18.7597 5.01953 20.6014 6.14523 21.7249C7.23333 22.8114 8.81873 22.9681 10.3102 23.0048C10.995 23.0232 11.5792 23.0325 12.1635 23.0325C12.7478 23.0325 13.332 23.0232 14.0168 23.0048C15.4989 22.9681 17.0936 22.8114 18.1819 21.7249C19.3074 20.6014 19.2982 18.7597 19.3262 17.3046C19.3357 16.706 19.345 16.0982 19.3357 15.4997C19.3357 14.9012 19.3357 14.3026 19.3262 13.6948C19.2981 12.2397 19.3074 10.3979 18.1819 9.2743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8409 10.64C23.6483 10.64 23.4508 10.6944 23.2644 10.8138L19.8827 12.9803V18.019L23.2644 20.1853C23.4508 20.3047 23.6485 20.3593 23.8411 20.3593C24.4452 20.3593 24.9994 19.8232 24.9994 19.0739V11.9255C24.9994 11.1764 24.445 10.64 23.8409 10.64Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3940_21520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.8d120dc80c96ee5e7979ab7b83987134.svg";
export { ForwardRef as ReactComponent };